import { render, staticRenderFns } from "./WinModal.vue?vue&type=template&id=0048c56f&scoped=true"
import script from "./WinModal.vue?vue&type=script&lang=js"
export * from "./WinModal.vue?vue&type=script&lang=js"
import style0 from "./WinModal.vue?vue&type=style&index=0&id=0048c56f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0048c56f",
  null
  
)

export default component.exports